import isString from 'lodash/isString';

import { isLiteral } from './guards';
import type { Nullable } from './object';

export function isEmpty<T>(arg: T[]): boolean;
export function isEmpty(arg: Nullable<string>): arg is Nullable<''>;
export function isEmpty<T>(arg: Nullable<T>): arg is null | undefined;
export function isEmpty<T>(arg: T): boolean {
  if (arg === null || arg === undefined) {
    return true;
  }

  if (isString(arg) && arg.trim() === '') {
    return true;
  }

  if (isLiteral(arg) && Object.keys(arg).length === 0) {
    return true;
  }

  if (Array.isArray(arg) && arg.length === 0) {
    return true;
  }

  return false;
}

export function isNotEmpty<T>(arg: T[]): boolean;
export function isNotEmpty<T>(arg: Nullable<T>): arg is T;
export function isNotEmpty<T>(arg: T): boolean {
  return !isEmpty(arg);
}

export const isNotEmptyString = <T extends string>(str: Nullable<T>): str is Exclude<T, ''> => {
  if (str === null || str === undefined) {
    return false;
  }

  if (str.trim() === '') {
    // throw Error('Asserted string was empty');
    return false;
  }

  return true;
};
